import { useId } from 'react'
import { twMerge } from 'src/utils/tw-merge.util'

const PATH =
  'M20.8385 1.1642C14.0149 -0.388067 7.98622 -0.388067 1.16262 1.1642C0.764609 1.28813 0.5 1.599 0.5 1.9708C0.566152 3.8329 0.566152 5.69397 0.566152 7.61804C0.566152 15.8101 0.301544 16.2438 7.25744 21.3943C8.31698 22.2009 9.37762 23.0075 10.4372 23.8141C10.7679 24.062 11.2321 24.062 11.4967 23.8141C12.5562 23.0075 13.683 22.2009 14.7426 21.3943C21.6323 16.2438 21.3677 15.809 21.4338 7.61804C21.4338 5.69397 21.4338 3.8329 21.5 1.9708C21.5 1.59797 21.2354 1.28813 20.8374 1.1642H20.8385ZM17.801 8.09725L10.4416 14.2516L9.68964 14.8806C9.45369 15.0778 9.08875 15.0613 8.87266 14.8454L8.18578 14.1555L4.78666 10.737C4.54631 10.4933 4.56174 10.1132 4.82194 9.88809L6.23429 8.67045C6.49449 8.4453 6.90573 8.46182 7.14609 8.7035L9.47023 11.0407L15.6499 5.87368C15.9135 5.65266 16.3214 5.67435 16.5595 5.91809L17.8473 7.25037C18.0854 7.49721 18.0623 7.87727 17.7999 8.09725H17.801Z'

const GRADIENT_STOPS = {
  default: (
    <>
      <stop offset="0%" stopColor="#3333CC" />
      <stop offset="50%" stopColor="#3386CC" />
      <stop offset="100%" stopColor="#33CCCC" />
    </>
  ),
  tooltip: (
    <>
      <stop offset="0%" stopColor="#8888FC" />
      <stop offset="100%" stopColor="#33CCCC" />
    </>
  ),
  button: (
    <>
      <stop offset="0%" stopColor="#DEFAFA" />
      <stop offset="100%" stopColor="#D9E2FF" />
    </>
  ),
}

const AdminOnlyBadge = ({
  variant = 'default',
  className,
}: {
  variant?: 'default' | 'tooltip' | 'button'
  className?: string
}) => {
  const uid = useId()
  const gradientId = `admin-badge-gradient-${uid}`

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge('c-h-3.5 c-w-3.5 c-shrink-0 c-mt-0.5', className)}
    >
      <defs>
        <linearGradient id={gradientId} x1="14" y1="0" x2="14" y2="28" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS[variant]}
        </linearGradient>
      </defs>
      <path fillRule="evenodd" clipRule="evenodd" d={PATH} fill={`url(#${gradientId})`} />
    </svg>
  )
}

export { AdminOnlyBadge }
